import { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { SimpleTooltip } from '@/components/ui/simple-tooltip';
import { IntegrationServices } from '@/modules/common/types/integrations';
import { getIntegrationIcon } from '@/modules/common/utils/integration-icons';

interface QuickBooksSyncedLabelProps {
  label: ReactNode;
  isSynced: boolean;
}

export function QuickBooksSyncedLabel({ label, isSynced }: QuickBooksSyncedLabelProps) {
  const { t } = useTranslation(['authenticated.clients']);

  if (!isSynced) return <>{label}</>;

  return (
    <span className="inline-flex items-center gap-1.5">
      {label}
      <SimpleTooltip content={t('details.quickBooksSync.badgeTooltip')}>
        <span
          className="inline-flex items-center rounded-full border px-1 py-0.5"
          aria-label={t('details.quickBooksSync.badge')}
          role="img"
        >
          <img
            src={getIntegrationIcon(IntegrationServices.QUICKBOOKS)}
            alt=""
            className="h-3.5 w-3.5 shrink-0"
          />
        </span>
      </SimpleTooltip>
    </span>
  );
}
